/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const releaseAstraIdentityCollisionParams = zod.object({
  "id": zod.string().uuid()
})

export const rejectAstraIdentityCollisionParams = zod.object({
  "id": zod.string().uuid()
})

export const rejectAstraIdentityCollisionBodyReasonMax = 500;



export const rejectAstraIdentityCollisionBody = zod.object({
  "reason": zod.string().max(rejectAstraIdentityCollisionBodyReasonMax).nullish()
})

export const attachAstraIdentityCollisionToSuspectedDuplicateUserParams = zod.object({
  "id": zod.string().uuid()
})

export const attachAstraIdentityCollisionToSuspectedDuplicateUserResponse = zod.object({
  "suspectedDuplicateUserId": zod.string().uuid()
})

